module.exports = __webpack_public_path__ + "img/honour-3.bcd25a42.png";